__turbopack_context__.v({
  "agentBubble": "website-workflow-demos-module__zVdLiW__agentBubble",
  "bar": "website-workflow-demos-module__zVdLiW__bar",
  "body": "website-workflow-demos-module__zVdLiW__body",
  "card": "website-workflow-demos-module__zVdLiW__card",
  "cardHeading": "website-workflow-demos-module__zVdLiW__cardHeading",
  "chatMessages": "website-workflow-demos-module__zVdLiW__chatMessages",
  "composer": "website-workflow-demos-module__zVdLiW__composer",
  "customerBubble": "website-workflow-demos-module__zVdLiW__customerBubble",
  "focused": "website-workflow-demos-module__zVdLiW__focused",
  "grid": "website-workflow-demos-module__zVdLiW__grid",
  "initials": "website-workflow-demos-module__zVdLiW__initials",
  "input": "website-workflow-demos-module__zVdLiW__input",
  "instruction": "website-workflow-demos-module__zVdLiW__instruction",
  "instructionPill": "website-workflow-demos-module__zVdLiW__instructionPill",
  "label": "website-workflow-demos-module__zVdLiW__label",
  "monitorAgent": "website-workflow-demos-module__zVdLiW__monitorAgent",
  "monitorAttention": "website-workflow-demos-module__zVdLiW__monitorAttention",
  "monitorConversation": "website-workflow-demos-module__zVdLiW__monitorConversation",
  "monitorConversationTitle": "website-workflow-demos-module__zVdLiW__monitorConversationTitle",
  "monitorCustomer": "website-workflow-demos-module__zVdLiW__monitorCustomer",
  "monitorGroup": "website-workflow-demos-module__zVdLiW__monitorGroup",
  "monitorRow": "website-workflow-demos-module__zVdLiW__monitorRow",
  "monitorRows": "website-workflow-demos-module__zVdLiW__monitorRows",
  "monitorSentiment": "website-workflow-demos-module__zVdLiW__monitorSentiment",
  "monitorSidebar": "website-workflow-demos-module__zVdLiW__monitorSidebar",
  "monitorSlot": "website-workflow-demos-module__zVdLiW__monitorSlot",
  "monitorThinking": "website-workflow-demos-module__zVdLiW__monitorThinking",
  "monitorTools": "website-workflow-demos-module__zVdLiW__monitorTools",
  "monitorVisitor": "website-workflow-demos-module__zVdLiW__monitorVisitor",
  "monitorWorkspace": "website-workflow-demos-module__zVdLiW__monitorWorkspace",
  "notificationCount": "website-workflow-demos-module__zVdLiW__notificationCount",
  "notificationHeading": "website-workflow-demos-module__zVdLiW__notificationHeading",
  "notificationIcon": "website-workflow-demos-module__zVdLiW__notificationIcon",
  "notificationMessage": "website-workflow-demos-module__zVdLiW__notificationMessage",
  "number": "website-workflow-demos-module__zVdLiW__number",
  "outcome": "website-workflow-demos-module__zVdLiW__outcome",
  "pressed": "website-workflow-demos-module__zVdLiW__pressed",
  "root": "website-workflow-demos-module__zVdLiW__root",
  "sourceRow": "website-workflow-demos-module__zVdLiW__sourceRow",
  "spin": "website-workflow-demos-module__zVdLiW__spin",
  "spinner": "website-workflow-demos-module__zVdLiW__spinner",
  "stage": "website-workflow-demos-module__zVdLiW__stage",
  "statusDot": "website-workflow-demos-module__zVdLiW__statusDot",
  "tabs": "website-workflow-demos-module__zVdLiW__tabs",
  "thinking": "website-workflow-demos-module__zVdLiW__thinking",
  "tile": "website-workflow-demos-module__zVdLiW__tile",
  "upload": "website-workflow-demos-module__zVdLiW__upload",
});
